import React from 'react';
import { NextPage } from 'next';
import { Col, Row } from '@sumup-oss/circuit-ui/legacy';

import { getPosIndexStaticProps } from './posStatic';

import { Props } from 'types/index';
import TypedSections from 'components/TypedSections';
import { TypeContainer } from 'components/styledComponents';

const POS: NextPage<Props> = ({ sectionTree, articles, sectionTypeTree }) => (
  <Col span="12" skip="0">
    <Row>
      <TypeContainer>
        <TypedSections
          sectionTree={sectionTree}
          articles={articles}
          sectionTypeTree={sectionTypeTree}
          isPos
        />
      </TypeContainer>
    </Row>
  </Col>
);

export const getStaticProps = getPosIndexStaticProps;

export default POS;
